import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Alert, Button, Form, ListGroup, Table, Dropdown } from "react-bootstrap";
import { getAllMpBasePuestos } from "../../../../../crud/configuration_api/mp_base_puestos";
import { is } from "date-fns/locale";
import "./CreatePuestos.scss";
import { ChevronLeft, ChevronRight } from 'react-bootstrap-icons';
import { Workstation,Puesto } from "../../types";


interface CreatePuestoProps {
  index: number;
  moveFunctions: {
    next: () => void;
    back: () => void;
  };
  setPayload: (data: any) => void;
  accountCode: string;
  workstations?: Workstation[];
  puestos?: Puesto[];
  setPuestos?: (data: Puesto[]) => void;
}

interface PuestoItem {
  puesto_name: string;
  puesto_description?: string;
  state: boolean;
  local_id: number;
  workstation_id: string | null;
  base_puesto_id?: number | null;
  code: string;
  checked?: boolean;
  takesOrders?: boolean; 
  is_waiter?: boolean;
}

interface WorkstationItem {
  workstation_id: number;
  workstation_name: string;
}


const CreatePuesto: React.FC<CreatePuestoProps> = ({
  index,
  moveFunctions,
  setPayload,
  accountCode,
  workstations = [], // <-- Usar prop
  puestos,
  setPuestos,
}) => {
  const storedData = JSON.parse(localStorage.getItem("RegistrationMemory") || "{}");
  const localData = storedData[1] || {};
  const [error, setError] = useState<string | null>(null);
  // Elimina el estado y fetch de workstations
 
  const [newName, setNewName] = useState("");
  const [newDesc, setNewDesc] = useState("");
  const [options, setOptions] = useState<PuestoItem[]>([]);
  const [takesOrders, setTakesOrders] = useState(false);
  const [newStationId, setNewStationId] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const resp = await getAllMpBasePuestos();
        if (resp?.data) {
          const mapped: PuestoItem[] = resp.data.map((item: any) => ({
            puesto_name: item.name,
            puesto_description: item.description,
            takesOrders: false,
            is_waiter: false,
            checked : false,
            base_puesto_id: item.mp_base_puesto_id,
            local_id: localData.local_id || 0,
            workstation_id: newStationId,
            code: accountCode,
          }));
          mapped.sort((a, b) => a.puesto_name.localeCompare(b.puesto_name));
          setOptions(mapped);
        }
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);
  
  const toggleChecked = (name: string) => {
    setOptions((prev) =>
      prev.map((w) =>
        w.puesto_name === name ? { ...w, checked: !w.checked } : w
      )
    );
  };

  const toggleOrders = (name: string) => {
    setOptions((prev) =>
      prev.map((w) =>
        w.puesto_name === name ? { ...w, takesOrders: !w.takesOrders } : w
      )
    );
  };

  const addCustomOption = () => {
    if (!newName.trim()) {
      setError("El nombre del puesto es requerido.");
      return;
    }
    if (options.some((w) => w.puesto_name === newName.trim())) {
      setError("El puesto ya existe.");
      return;
    }
    setError(null);
    const newOption: PuestoItem = {
      puesto_name: newName.trim(),
      puesto_description: newDesc.trim(),
      checked: true,
      takesOrders: takesOrders,
      is_waiter: takesOrders,
      base_puesto_id:null,
      local_id: localData.local_id || 0,
      workstation_id: newStationId,
      state: true,
      code: accountCode,
    };

    setOptions(prev => [ newOption, ...prev ]);
    setNewName("");
    setNewDesc("");
    setTakesOrders(false);
    setNewStationId(null);
  };

  const validateAndSubmit = () => {
  const selected = options.filter(w => w.checked);
  if (!selected.length) {
    setError("Debes seleccionar al menos un puesto.");
    return;
  }
  setError(null);

  const payloadToSend = selected.map(w => ({
    puesto_name:       w.puesto_name,
    puesto_description:w.puesto_description,
    state:             true,
    local_id:          w.local_id,
    workstation_id:    w.workstation_id,    
    code:              w.code,
    is_waiter:         !!w.takesOrders,     
    base_puesto_id:    w.base_puesto_id ?? null 
  }));

  setPayload(payloadToSend);
  moveFunctions.next();
};

  const handleStationChange = (
    puestoName: string,
    stationId: string | null
  ) => {
    setOptions((prev) =>
      prev.map((w) =>
        w.puesto_name === puestoName
          ? { ...w, workstation_id: stationId }
          : w
      )
    );
  };


  

  

  

  return (
    <div className="container-create-puesto">
      <div className="logo-container-preg">
        <img
          src="/logos/Recurso 40MEDIOPUNTO.png"
          alt="Logo Mediopunto"
          className="registration-logo-preg"
        />
      </div>
      <div className="info-guide-preg">
        <h2 className="Title-Step-Registration-preg">Crea un puesto de trabajo </h2>
        <p>
          <FontAwesomeIcon icon={faInfoCircle} size="sm" className="info-icon" />{' '}
          Genial, ya casi has terminado con tu registro. Ahora tendrás que
          agregar un puesto de trabajo que creaste
          anteriormente. Dales un nombre y una descripción a estos puestos
          (El campo de la descripción es opcional).
        </p>
      </div>

      {/* Lista de puestos base */}
      <div
        style={{
          display: "block",
          maxHeight: "16rem",
          overflowY: "auto",
          border: "1px solid #dee2e6",
          borderRadius: ".25rem",
        }}
      >
        <Table
          borderless
          hover
          size="sm"
          style={{ tableLayout: "fixed", width: "100%", marginBottom: 0 }}
        >
          <thead>
            <tr>
              <th style={{ width: "8%" }} className="text-center">Activo</th>
              <th style={{ width: "20%" }}>Nombre</th>
              <th style={{ width: "35%" }}>Descripción</th>
              <th style={{ width: "11%" }} className="text-center">Toma pedidos</th>
              <th style={{ width: "20%" }}>Estación de trabajo</th>
            </tr>
          </thead>
          <tbody>
            {options.map(opt => (
              <tr key={opt.puesto_name}>
                <td className="text-center align-middle">
                  <div className="mediopunto-checkbox-container puestos-checkbox" style={{marginLeft:'20px'}}>
                  <input
                    id={`checkbox-${opt.puesto_name}`}
                    type="checkbox"
                    name="isSelected"
                    checked={!!opt.checked}
                    onChange={() => toggleChecked(opt.puesto_name)}
                  />
                  <label
                    htmlFor={`checkbox-${opt.puesto_name}`}
                    className="mediopunto-checkbox-label"
                  ></label>
                  </div>
                </td>
                <td className="align-middle">{opt.puesto_name}</td>
                <td className="align-middle">{opt.puesto_description}</td>
                <td className="text-center align-middle">
                  <Form.Group className="form-group-preg align-items-center">
                          <div>
                            <label className="switch me-2 mb-0">
                              <input
                                type="checkbox"
                                checked={opt.takesOrders}
                                onChange={(e) => toggleOrders(opt.puesto_name)}
                              />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </Form.Group>
                </td>
                 <td className="align-middle">
                  <div className="form-group-dropdown-preg" >
                  <Dropdown className="dropdown-workstation" drop="down" >
                    <Dropdown.Toggle 
                      size="sm" 
                      variant="none" 
                      style={{ width: '110%', textAlign: 'left' }}
                    >
                      {
                        !opt.workstation_id || !workstations.some(w => w.workstation_id === opt.workstation_id)
                          ? "Sin estación"
                          : workstations.find(w => w.workstation_id === opt.workstation_id)?.workstation_name
                      }
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ maxHeight: '10rem', overflowY: 'auto', width: '100%'}}>
                      <Dropdown.Item 
                        onClick={() => handleStationChange(opt.puesto_name, null)}
                      >
                        Sin estación
                      </Dropdown.Item>
                      {workstations.map(ws => (
                        <Dropdown.Item 
                          key={ws.workstation_id}
                          onClick={() => handleStationChange(opt.puesto_name, ws.workstation_id)}
                        >
                          {ws.workstation_name}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                </td>
              </tr>
            ))}

          </tbody>
        </Table>
      </div>

      
      

      {error && <Alert variant="danger">{error}</Alert>}
      <div className="form-create-workstation">
          <span>Crea tus propios puestos</span>
          <div className="form-input-workstation">
              <Form.Group className="form-group-preg">
              <Form.Control
                type="text"
                id="puesto_name"
                name="puesto_name"
                className="input-workstation"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                required
                placeholder="Nombre del Puesto"
              />
            </Form.Group>

            <Form.Group className="form-group-preg">
              <Form.Control
                type="text"
                id="puesto_description"
                name="puesto_description"
                className="input-workstation"
                value={newDesc}
                onChange={(e) => setNewDesc(e.target.value)}
                required
                placeholder="Descripción del Puesto"
              />
            </Form.Group>
            </div>
        

            <Form.Group className="form-input-create-workstation">
              <Form.Label>Estación de trabajo</Form.Label>
              <div className="form-group-dropdown-preg d-flex justify-content-center">
                <Dropdown>
                  <Dropdown.Toggle
                    size="sm"
                    variant="none"
                  >
                    {workstations.find((w) => w.workstation_id === newStationId)?.workstation_name ?? 'Sin estación'}
                  </Dropdown.Toggle>
                  <Dropdown.Menu style={{ maxHeight: '10rem', overflowY: 'auto', width: '50%' }}>
                    <Dropdown.Item onClick={() => setNewStationId(null)}>
                      Sin estación
                    </Dropdown.Item>
                    {workstations.map((ws) => (
                      <Dropdown.Item
                        key={ws.workstation_id}
                        onClick={() => setNewStationId(ws.workstation_id)}
                      >
                        {ws.workstation_name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="contenedor-switch-span">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={takesOrders}
                    onChange={(e) => setTakesOrders(e.target.checked)}
                  />
                  <span className="slider round"></span>
                </label>
                <span style={{ color: '#333' }}>¿Toma pedidos?</span>
              </div>
            </Form.Group>

            {/* 2) dropdown para asignar estación */}
            

            <Form.Group className="form-group-preg">
                <div className="container-plus-workstation">
                  <Button variant="none" className="mp-button light" onClick={addCustomOption}>
                    Agregar
                  </Button>
                </div>
            </Form.Group>

            <div className="button-group">
              <Button className="BackStep_Registration-preg" type="button" variant="none" onClick={moveFunctions.back}>
                <ChevronLeft /> Anterior
              </Button>
              <Button className="NextStep_Registration-preg" type="button" variant="none" onClick={validateAndSubmit}>
                Siguiente <ChevronRight />
              </Button>
            </div>
        </div>
      </div>      
  );
};

export default CreatePuesto;
